export default __webpack_public_path__ + "static/media/doctor_consultation_locked.134337bb.png";